var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGearbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 254.533 254.533",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.267,0C57.092,0,0,57.091,0,127.266s57.092,127.267,127.267,127.267s127.267-57.092,127.267-127.267 S197.441,0,127.267,0z M127.269,226.336c-54.627,0-99.069-44.442-99.069-99.07s44.442-99.071,99.069-99.071 c54.628,0,99.071,44.443,99.071,99.071S181.896,226.336,127.269,226.336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.144,81.838c-4.4,0-7.968,3.567-7.968,7.968v30.145h-23.982V89.806c0-4.4-3.567-7.968-7.968-7.968 s-7.968,3.567-7.968,7.968v30.145h-23.984V89.806c0-4.4-3.567-7.968-7.968-7.968c-4.4,0-7.968,3.567-7.968,7.968v30.145H75.354 V89.806c0-4.4-3.567-7.968-7.968-7.968c-4.4,0-7.968,3.567-7.968,7.968v34.832c0,7.729,4.791,11.248,9.243,11.248h30.677v28.842 c0,4.4,3.567,7.968,7.968,7.968c4.4,0,7.968-3.567,7.968-7.968v-28.842h23.984v28.842c0,4.4,3.567,7.968,7.968,7.968 s7.968-3.567,7.968-7.968v-28.842h23.982v28.842c0,4.4,3.567,7.968,7.968,7.968c4.4,0,7.968-3.567,7.968-7.968V89.806 C195.112,85.406,191.545,81.838,187.144,81.838z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearbox);
export default __webpack_public_path__ + "static/media/gearbox.20cfbb4ca1ef972835c3f4502fe664f1.svg";
export { ForwardRef as ReactComponent };